;(function () {
  angular.module('contrast.avatar').controller('csAvatarCtrl', csAvatarCtrl)

  function csAvatarCtrl($uibModal) {
    'ngInject'

    var vm = this

    angular.extend(vm, {
      onClick: onClick,
      hasAvatar: hasAvatar
    })

    function onClick() {
      $uibModal
        .open({
          templateUrl: 'views/common/avatarpicker.html',
          controller: 'avatarPickerCtrl',
          controllerAs: 'avatarPickerCtrl',
          size: 'md'
        })
        .result.then(function (image) {
          vm.avatar = image
        })
    }

    function hasAvatar() {
      return vm.avatar || vm.avatarUrl
    }
  }
})()
